import { Component } from '@angular/core';
import { HeroBannerComponent } from '../Components/hero-banner/hero-banner.component';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [HeroBannerComponent],
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss',
})
export class PrivacyPolicyComponent {}
